import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DomainIcon(props: IconProps) {
    return <Icon {...props} iconKey={"domain"}/>
}
